import { fmtCFA, fmtDate } from "@/lib/format";
import { esc } from "@/lib/print";
import { LOGO_BW_SVG } from "@/lib/recuPrefs";

const LABELS = { especes: "Espèces", wave: "Wave", orange_money: "Orange Money" };

const TICKET_CSS = `
  @page { size: 80mm auto; margin: 0; }
  html, body { margin: 0; padding: 0; width: 80mm; background: #fff; }
  body { font-family: "Courier New", monospace; font-size: 11px; line-height: 1.3; color: #000; }
  .t { width: 80mm; padding: 3mm 4mm; box-sizing: border-box; page-break-after: always; break-after: page; }
  .t:last-child { page-break-after: auto; break-after: auto; }
`;
const A4_CSS = `
  @page { size: A4; margin: 12mm; }
  html, body { margin: 0; padding: 0; background: #fff; }
  body { font-family: "Courier New", monospace; font-size: 13px; line-height: 1.4; color: #000; }
  .t { max-width: 520px; margin: 0 auto; padding: 24px; page-break-after: always; break-after: page; }
  .t:last-child { page-break-after: auto; break-after: auto; }
`;
const COMMON = `
  .c { text-align: center; } .b { font-weight: bold; } .big { font-size: 1.35em; letter-spacing: .5px; }
  hr { border: 0; border-top: 1px dashed #000; margin: 6px 0; }
  table { width: 100%; border-collapse: collapse; } td { padding: 1px 0; vertical-align: top; }
  td.r { text-align: right; white-space: nowrap; padding-left: 6px; }
  .row { display: flex; justify-content: space-between; }
  img, svg { display: block; margin: 0 auto 4px; object-fit: contain; }
  img.logo { filter: grayscale(1) contrast(1.6) brightness(1.05); -webkit-print-color-adjust: exact; print-color-adjust: exact; }
`;

const logoHTML = (logoUrl, a4) => {
  const s = a4 ? 90 : 56;
  return logoUrl
    ? `<img class="logo" src="${esc(logoUrl)}" width="${s}" height="${s}" alt="">`
    : LOGO_BW_SVG.replace('width="56" height="56"', `width="${s}" height="${s}"`);
};

function ticketHTML(v, logoUrl, a4) {
  const items = v.items.map((i) => `<tr><td>${i.quantite}× ${esc(i.nom)}</td><td class="r">${fmtCFA(i.prix * i.quantite)}</td></tr>`).join("");
  return `<div class="t">
    <div class="c">
      ${logoHTML(logoUrl, a4)}
      <div class="b big">LAC ROSE FITNESS</div>
      <div>Reçu de caisse</div>
      <div>${esc(fmtDate(v.created_at))}</div>
      <div>N° ${esc(v.id.slice(0, 8).toUpperCase())}</div>
    </div>
    <hr><table>${items}</table><hr>
    <div class="row b big"><span>TOTAL</span><span>${fmtCFA(v.total)}</span></div>
    <div class="row"><span>Paiement</span><span>${LABELS[v.paiement] || esc(v.paiement)}</span></div>
    ${v.reference ? `<div class="row"><span>Réf. transaction</span><span>${esc(v.reference)}</span></div>` : ""}
    <div class="row"><span>Vendeur</span><span>${esc(v.vendeur_nom || "")}</span></div>
    <hr><div class="c">Merci de votre visite !</div>
  </div>`;
}

export function imprimerRecu(vente, { logoUrl, format = "ticket", copies = 1 }) {
  const a4 = format === "a4";
  const body = Array.from({ length: copies }, () => ticketHTML(vente, logoUrl, a4)).join("");
  const w = window.open("", "_blank", a4 ? "width=800,height=900" : "width=420,height=700");
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Reçu ${esc(vente.id.slice(0, 8).toUpperCase())}</title><style>${a4 ? A4_CSS : TICKET_CSS}${COMMON}</style></head><body>${body}
<script>window.onafterprint=function(){window.close()};function go(){setTimeout(function(){window.focus();window.print()},150)}
var imgs=document.images;if(imgs.length&&!imgs[0].complete){imgs[0].onload=go;imgs[0].onerror=go;}else{go();}</script></body></html>`);
  w.document.close();
  return true;
}
